<template>
  <div>
    <div v-if="(currentRole.RolesInfo.length !== 0) || (currentRole.pendingRequests.length !== 0)">
      <div class="border">
        <div class="headerRoles">
          <div class="headerboxlablerole1">Resource</div>
          <div class="headerboxlablerole23">Role</div>
          <div class="headerboxlablerole23">Status</div>
        </div>
        <div v-if="(currentRole.pendingRequests.length !== 0)">
          <div class="contentToDisplay">
            <div class="sideHeaderContainer">
              <div class="sideheader"> Pending </div>
            </div>

            <div v-for="(role,index) in currentRole.pendingRequests" :key="index" >
              <div class="rolesStatus">

                <div class="resourceNameValue">
                  {{ role.processVariables.resourceName }}
                </div>
                <div class="roleValueroleStatus">
                  {{ role.processVariables.roleName }}
                </div>
                <div class="roleValueroleStatus  valueColor">
                  <FrIcon class="mr-2" :outlined="false" name="autorenew" /> Pending
                </div>
              </div>
            </div>

          </div>
        </div>
        <div v-if="(currentRole.RolesInfo.length !== 0)">
          <div class="contentToDisplay">
            <div class="sideHeaderContainer">
              <div class="sideheader"> Active</div>
            </div>
            <div v-for="(role,index) in currentRole.RolesInfo"  :key="index">
              <!-- <div v-if="(!role.processVariables.taskDeleted) && (!role.processVariables.rejected)"> -->
                <div class="rolesStatus">

                  <div class="resourceNameValueroleStatus">
                    {{ role.resourceName }}
                  </div>
                  <div class="roleValue">
                    {{ role.name }}
                  </div>
                  <div class="roleValue">
                    <FrIcon class="mr-2" :outlined="false" name="done" /> Active
                  </div>
                </div>
              <!-- </div> -->
            </div>

          </div>
        </div>
      </div>
    </div>
    <div v-else> No Roles to Show</div>

  </div>
</template>

<script>
import { generateIdmApi } from '../../../api/BaseApi';
import FrIcon from '@forgerock/platform-shared/src/components/Icon';

export default {
  name: 'RelationshipView',
  components: {
    FrIcon,
  },
  props: {
    parentId: {
      type: String,
      required: true,
    }
  },

  data() {
    return {
      currentRole: [],
      realmIsEA: (localStorage.getItem('originalLoginRealm') == '/EA' || localStorage.getItem('originalLoginRealm') == 'EA' || localStorage.getItem('originalLoginRealm') == 'EA/') ? true : false,
    }
  },
  mounted() {
    this.getRoleRequestData();

  },
  methods: {
    getRoleRequestData() {

      if(this.realmIsEA){
        generateIdmApi().get('/endpoint/eaGetAdminUserRoles?userId=' + this.parentId).then((response) => {
          //  this.currentRole=response.data.RolesInfo
          this.currentRole = response.data
          console.log(this.currentRole)
        })
      } else {
        generateIdmApi().get('/endpoint/getAdminUserRoles?userId=' + this.parentId).then((response) => {
          //  this.currentRole=response.data.RolesInfo
          this.currentRole = response.data
          console.log(this.currentRole)
        })
      }
      // generateIdmApi().get('/endpoint/getUserRolesList').then((response)=>{
    }
  }
}
</script>

<style>
.rolesStatus {
  min-width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 24px;
  border-top: 1px solid #E3E5E8;
  border-left: 1px solid #E3E5E8;
  border-right: 1px solid #E3E5E8;

}

.resourceNameValueroleStatus {
  width: 50%;
  min-height: 24px;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  color: #000000;

}

.roleValueroleStatus {
  width: 25%;
  min-height: 24px;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  color: #000000;
  /* border: 1px solid red; */
}

.border {
  border: 1px solid #F7F7F7;
}

.headerRoles {
  display: flex;
  height: 48px;
  align-items: center;
  gap: 10px;


}

.headerboxlablerole1 {
  width: 50%;
  height: 24px;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  padding-left: 24px;
  display: flex;
  align-items: center;
  color: #000000;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.headerboxlablerole23 {
  width: 25%;
  height: 24px;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #000000;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.sideheader {
  width: 100%;
  height: 22px;
  font-size: 12px;
  line-height: 18px;
  color: #5B6376;
  font-weight: 600;
  display: flex;
  align-items: center;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.sideHeaderContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 24px;
  width: 100%;
  height: 32px;
  background: #F7F7F7;
  border: 1px solid #E3E5E8;
  text-transform: uppercase;
}

.contentToDisplay {
  display: flex;
  flex-direction: column;

}

.valueColor {
  color: #00A9E0
}
</style>